const getSubsidiaryId = (subsidiary) => {
    const subsidiaryMap = {
        be: 3,
        nl: 1,
        de: 5,
    };
    return subsidiaryMap[subsidiary];
};
export default getSubsidiaryId;
//# sourceMappingURL=subsidiary.js.map